import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
    MitsHeaderComponent,
    PossibleColors,
} from "./mits-header.component";

@Component({
  selector: "mits-header",
  template: "",
})
export class MockMitsHeaderComponent implements Partial<MitsHeaderComponent> {
  /** Title of the header */
  @Input() title: string;
  /** FLAG: Is the header in a modal? */
  @Input() color: PossibleColors = "primary";
  /** FLAG: Is the header in a modal? */
  @Input() modal? = false;
  /** Default path to go to previous pages */
  @Input() defaultHref?: string;
  /** FLAG: Is the back-button needed? */
  @Input() backButton? = true;
  /** FLAG: Should "this.location.back used instead of defaultHref" */
  @Input() useLocationBack? = false;
  /** FLAG: Should this route be used for navigating back? */
  @Input() onlyDefaultHref? = false;
  /** FLAG: Should the closing be allowed? */
  @Input() allowClose? = true;

  @Output() closed: EventEmitter<any> = new EventEmitter();
  // Event emitter for navigatingBack
  @Output() backNavigationComplete: EventEmitter<any> = new EventEmitter();
}
